<h3 class="text-center text-lg mb-4">Oops...</h3>

<div class="flex justify-center gap-4">
  <p>
    We've encountered an error: {{ reason }}
    <br />
    Please reload the page.
  </p>

  <button mat-raised-button color="primary" type="button" (click)="reload()">
    Reload
  </button>
</div>
